<template>
  <div class="profile">
    <h1 class="profile__name" v-text="profile.name"></h1>
    <h2 class="profile__screanname">
      <a :href="'https://twitter.com/' + profile.screanname" target="_blank">@<span v-text="profile.screanname"></span></a>
    </h2>
    <p class="profile__bio" v-text="profile.bio"></p>
    <div class="profile__location">
      <i class="fa fa-map-marker"></i>
      <span v-text="profile.location"></span>
    </div>
    <div class="profile__birthday">
      <i class="fa fa-birthday-cake"></i>
      <span>{{profile.birth | birthDay}}</span>
    </div>
    <div class="profile__url">
      <ul>
        <li v-for="url in profile.urls">
          <i class="fa fa-link"></i>
          <a :href="url.href" target="_blank" v-text="url.link"></a>
        </li>
      </ul>
    </div>
    <div class="profile__certificates">
      <ul>
        <li v-for="certificate in profile.remarks.certificates">
          <i class="fa fa-ticket"></i>
          <span v-text="certificate.name"></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.profile {
  display: inline-block;
  box-sizing: border-box;
  vertical-align: top;

  margin-top: 37px;
  margin-bottom: 25px;

  padding: 0 15px;

  width: 30%;
  min-width: 200px;
}

h1, h2 {
  margin: 0 0 5px 0;
}

i {
  color: #8899a6;
  width: 18px;
  height: 18px;
  text-align: center;

  font-size: 18px;
}

a {
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}

ul {
  margin-top: 5px;
  padding: 0;
  list-style-type: none;
}
li {
  margin-bottom: 2px;
}
.profile__name {
  font-size: 24px;
}

.profile__screanname {
  font-size: 14px;
}
.profile__screanname > a {
  color: #8899a6;
}

.profile__bio {
  /*word-break: break-all;*/
}

.profile__url, .profile__certificates {
  margin-top: 5px;
  border-top: 1px solid #e1e8ed;
}
</style>

<script>
export default {
  props: ['profile'],
  filters: {
    birthDay: (day) => {
      const splitDay = day.split('/')
      return `誕生日 ${splitDay[0]}年${splitDay[1]}月${splitDay[2]}日`
    }
  }
}
</script>



/** WEBPACK FOOTER **
 ** Profile.vue?2d240716
 **/